import axios from "axios";

export const fetchTags = () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/tags`);
};

export const translateTags = (tag: string) => {
    if (!tag) return;

    const newTag = tag.replace(/_/g, " ");

    return newTag;
};
